import { Box, Typography } from '@mui/material';

export const EditPromptModeOverlay = () => {
  return (
    <Box
      position="absolute"
      top="50%"
      left="50%"
      mt={8}
      sx={{
        transform: 'translate(-50%,-50%)',
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <Typography>
        We will update these Reason’s Definitions based on the prompt ✨
      </Typography>
    </Box>
  );
};
